import * as types from 'reducer/actionTypes'
import { isEmpty } from 'script/common';
import { jsonToCascader } from 'script/uniAdapter';

const requestInit = {
	url: '',
	param: [],
	method: 'GET',
	header: null,
	body: null
}

const responseInit = {
	header: null,
	body: null,
	cookie: null,
	status: null,
	error: null
}

const interfaceInit = {
	request: requestInit,
	response: responseInit,
	isRequestActive: true,
	responseSource: [],
	value:null,
	error: null
}

const initialState = {
	uniAdapterActive: false,	// Activate the Unified Adapter Settings tab
	sampleWebofficeURL: null,
	adapterParam: null,
	adapterParamIsValid: null,
	adapterList: [],
	connectParam: null,
	adapterName: {},

	// adapter interface
	start:interfaceInit,
	info:interfaceInit,
	get:interfaceInit,
	put:interfaceInit,
	lock:interfaceInit,
	unlock:interfaceInit,
	renew:interfaceInit,
};

export default function uniAdapter(state = initialState, action){
	switch(action.type){

		case types.SET_INTERFACE_RESPONSE_SOURCE:
			return {
				...state,
				[action.interfaceType]: {
					...state[action.interfaceType],
					responseSource: action.responseSource
				},
			}

		case types.SET_INTERFACE_IS_REQUEST_ACTIVE:
			return {
				...state,
				[action.interfaceType]: {
					...state[action.interfaceType],
					isRequestActive: action.isRequestActive
				},
			}

		/**
		 * FETCH SAGA
		 */
		//

		case types.FETCH_GET_UNIADAPTER_ACTIVE_STATUS_SUCCESS: 
			return {
				...state,
				uniAdapterActive: action.value?.single?.value ?? initialState.uniAdapterActive
			}

		case types.FETCH_GET_SAMPLE_WEBOFFICE_URL_SUCCESS:
			return {
				...state,
				sampleWebofficeURL: action.value
			}

		case types.FETCH_SET_SAMPLE_WEBOFFICE_URL_SUCCESS:
			return {
				...state,
				sampleWebofficeURL: action.value
			}
		
		case types.FETCH_SET_RESET_UNIADAPTER_INTERFACE_SUCCESS:
			window.location.reload();
			return{
				...state
			}

		case types.FETCH_GET_UNIADAPTER_INTERFACE_SUCCESS: 
			return {
				...state,
				[action.interfaceType]: {
					...state[action.interfaceType],
					request: action.value?.request ?? requestInit,
					isRequestActive: action.value?.isRequestActive ?? interfaceInit.isRequestActive,
					value: action.value?.value,
				},
			}
		case types.FETCH_GET_UNIADAPTER_HTTP_EXECUTE_SUCCESS:
			return {
				...state,
				[action.interfaceType]: {
					...state[action.interfaceType],
					request: action.request,
					response: action.response
				},
			}

		case types.FETCH_GET_UNIADAPTER_PARAMETER_SUCCESS:
			return {
				...state,
				adapterParam: action.value?.value,
				adapterParamIsValid : action.value?.valueIsValid
			}

		case types.FETCH_GET_UNIADAPTER_LIST_SUCCESS:
			return {
				...state,
				adapterList: action.value || []
			}

		case types.FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_SUCCESS:
			return {
				...state,
				connectParam: action.value || []
			}
		
		default:
			return state
	}
};